//courier and distribution login
// const logins = [
//   // courier
//   {
//     username: "test",
//     password: "123",
//     token:
//       "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJHTFMgRXhwcmVzcyBXZWJib29raW5nIFRlc3QiLCJpYXQiOjE2MTU1NTIxNjUsImV4cCI6MTY0NzA4ODE2NSwiYXVkIjoid3d3LmJvb2tpbmctZ2xzZXhwcmVzcy5kayIsInN1YiI6ImhlbGdlLnBldGVyc2VuQGdscy1kZW5tYXJrLmNvbSIsInVzZXJfaWQiOiI2NjYifQ.7tot4Z3iSEEM7tOmMYvEc_xAeFtgo8tda2Shp99EOSY"
//   },
//   // distribution
//   {
//     username: "test",
//     password: "456",
//     token:
//       "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJHTFMgRXhwcmVzcyBXZWJib29raW5nIFRlc3QiLCJpYXQiOjE2MTU1NTIxNjUsImV4cCI6MTY0NzA4ODE2NSwiYXVkIjoid3d3LmJvb2tpbmctZ2xzZXhwcmVzcy5kayIsInN1YiI6ImhlbGdlLnBldGVyc2VuQGdscy1kZW5tYXJrLmNvbSIsInVzZXJfaWQiOiIxMjMifQ.Jmb9QF0zQzw0hFoI_HCHx2KzqZTeerbAi87pG3_yV3o"
//   }
// ];

const init_company = {
  name: "GLS Express A/S",
  address: "Højager 2-4",
  zip: "2630",
  city: "Taastrup",
  country: "DK",
  vat_no: "14414002"
};

const init_courier_accounts = [
  {
    id: 2307,
    name: "DS Taastrup",
    address: "Højager 2-4",
    zip: "2630",
    city: "Taastrup",
    country: "DK",
    lat: "55.63607271",
    lon: "12.25677034",
    vat_no: "14414002"
  },
  {
    id: 4708,
    name: "DS Århus",
    address: "Omega 2",
    zip: "8382",
    city: "Hinnerup",
    country: "DK",
    lat: "56.233605",
    lon: "10.103532",
    vat_no: "14414002"
  },
  {
    id: 4715,
    name: "DS Aalborg",
    address: "Hedelund 17",
    zip: "9400",
    city: "Nørresundby",
    country: "DK",
    lat: "55.609619",
    lon: "9.963451",
    vat_no: "14414002"
  },
  {
    id: 9487,
    name: "Dachser Denmark Int. A/S",
    address: "Helseholmen 11",
    zip: "2650",
    city: "Hvidovre",
    country: "DK",
    lat: "57.0887451",
    lon: "12.462112",
    vat_no: "14414002"
  }
];

const init_distribution_accounts = [
  {
    id: 1182,
    name: "DSV Air & Sea A/S",
    address: "Nokiavej 30",
    zip: "8700",
    city: "Horsens",
    country: "DK",
    lat: "55.88308415",
    lon: "9.7684187",
    vat_no: "26366313"
  }
];

const init_courier_default_account = {
  id: 2307,
  name: "DS Taastrup",
  address: "Højager 2-4",
  zip: "2630",
  city: "Taastrup",
  country: "DK",
  lat: "55.63607271",
  lon: "12.25677034",
  vat_no: "14414002"
};

const init_distribution_default_account = {
  id: 1182,
  name: "DSV Air & Sea A/S",
  address: "Nokiavej 30",
  zip: "8700",
  city: "Horsens",
  country: "DK",
  lat: "55.88308415",
  lon: "9.7684187",
  vat_no: "26366313"
};

const init_courier_settings = [
  { type: "booking_type", value: "COURIER" },
  {
    type: "vehicle_types",
    value: [
      {
        name: "4pll - Kassebil",
        external_key: "4PLT",
        pallet_spaces: 4,
        loading_height: 200,
        loading_width: 180,
        loading_length: 350,
        max_weight: 1250,
        lift: null,
        pipes: { max_length: 300 },
        icon: "4pll.png"
      },
      {
        name: "8pll - Liftbil",
        external_key: "8PLT",
        pallet_spaces: 8,
        loading_height: 250,
        loading_width: 200,
        loading_length: 450,
        max_weight: 750,
        lift: { max_weight: 200 },
        pipes: { max_length: 450 },
        icon: "8pll.png"
      },
      {
        name: "15pll - Forvogn",
        external_key: "15PLT",
        pallet_spaces: 15,
        loading_height: 300,
        loading_width: 225,
        loading_length: 850,
        max_weight: 1800,
        lift: null,
        pipes: null,
        icon: "15pll.png"
      },
      {
        name: "32pll - Trækker",
        external_key: "32PLT",
        pallet_spaces: 32,
        loading_height: 300,
        loading_width: 250,
        loading_length: 1050,
        max_weight: 3500,
        lift: null,
        pipes: null,
        icon: "32pll.png"
      }
    ]
  },
  {
    type: "unittypes",
    value: [
      {
        name: "EU palle",
        external_key: "EU_PLT",
        calculation_factor_kg: 250
      },
      {
        name: "US palle",
        external_key: "US_PLT",
        calculation_factor_kg: 300
      },
      {
        name: "½ palle",
        external_key: "H_PLT",
        calculation_factor_kg: 125
      },
      { name: "KLL", external_key: "CLL" },
      { name: "Pakke", external_key: "PKG" }
    ]
  },
  { type: "edit_users_allowed", value: "true" },
  { type: "use_own_address_as", value: "Pickup" },
  { type: "own_address_editable", value: "false" },
  { type: "default_name", value: "Kunde" },
  { type: "hide_address_info", value: "false" },
  { type: "hide_contact", value: "false" },
  { type: "hide_goods_unit_type", value: "false" },
  { type: "hide_goods_length", value: "false" },
  { type: "hide_goods_width", value: "false" },
  { type: "hide_goods_height", value: "false" },
  { type: "hide_goods_cbm", value: "false" },
  { type: "hide_goods_reference", value: "false" },
  { type: "hide_goods_pipes", value: "false" },
  { type: "hide_goods_slv", value: "false" },
  { type: "hide_goods_adr", value: "false" },
  { type: "allow_add_goods", value: "true" },
  { type: "hide_booking_references", value: "false" },
  { type: "allow_empty_reference_1", value: "false" },
  { type: "hide_booking_remarks", value: "false" },
  { type: "default_notification_to_booker", value: "true" },
  { type: "hide_booking_insurance", value: "false" },
  { type: "hide_prices", value: "false" },
  { type: "prices_incl_vat", value: "true" }
];

const init_distribution_settings = [
  { type: "booking_type", value: "DISTRIBUTION" },
  {
    type: "vehicle_types",
    value: [
      {
        name: "4pll - Kassebil",
        external_key: "4PLT",
        pallet_spaces: 4,
        loading_height: 200,
        loading_width: 180,
        loading_length: 350,
        max_weight: 1250,
        lift: null,
        pipes: { max_length: 300 },
        icon: "4pll.png"
      },
      {
        name: "8pll - Liftbil",
        external_key: "8PLT",
        pallet_spaces: 8,
        loading_height: 250,
        loading_width: 200,
        loading_length: 450,
        max_weight: 750,
        lift: { max_weight: 200 },
        pipes: { max_length: 450 },
        icon: "8pll.png"
      }
    ]
  },
  {
    type: "unittypes",
    value: [
      {
        name: "EU palle",
        external_key: "EU_PLT",
        calculation_factor_kg: 250
      },
      {
        name: "US palle",
        external_key: "US_PLT",
        calculation_factor_kg: 300
      },
      {
        name: "½ palle",
        external_key: "H_PLT",
        calculation_factor_kg: 125
      },
      { name: "KLL", external_key: "CLL" },
      { name: "Pakke", external_key: "PKG" }
    ]
  },
  { type: "default_goods_cll", value: 1.0 },
  { type: "default_goods_weight", value: 10.0 },
  { type: "default_goods_description", value: "Gods" },
  { type: "default_vehicle_type", value: "8PLT" },
  { type: "edit_users_allowed", value: "false" },
  { type: "use_own_address_as", value: "Pickup" },
  { type: "own_address_editable", value: "false" },
  { type: "default_name", value: "" },
  { type: "hide_address_info", value: "false" },
  { type: "hide_contact", value: "true" },
  { type: "hide_goods_unit_type", value: "true" },
  { type: "hide_goods_length", value: "false" },
  { type: "hide_goods_width", value: "false" },
  { type: "hide_goods_height", value: "false" },
  { type: "hide_goods_cbm", value: "false" },
  { type: "hide_goods_reference", value: "false" },
  { type: "hide_goods_pipes", value: "true" },
  { type: "hide_goods_slv", value: "true" },
  { type: "hide_goods_adr", value: "true" },
  { type: "allow_add_goods", value: "false" },
  { type: "hide_booking_references", value: "false" },
  { type: "allow_empty_reference_1", value: "true" },
  { type: "hide_booking_remarks", value: "false" },
  { type: "default_notification_to_booker", value: "false" },
  { type: "hide_booking_insurance", value: "true" },
  { type: "hide_prices", value: "true" },
  { type: "prices_incl_vat", value: "false" }
];

const users = [
  {
    id: 1,
    user_name: "preben",
    first_name: "Preben",
    last_name: "Mogensen",
    email: "preben@mogensen.dk",
    phone: "11223344"
  },
  {
    id: 2,
    user_name: "ulla",
    first_name: "Ulla",
    last_name: "Terkelsen",
    email: "ulla@terkelsen.dk",
    phone: "12345678"
  },
  {
    id: 3,
    user_name: "olvir",
    first_name: "Ölvir",
    last_name: "Ölvirson",
    email: "olvir@olvirson.dk",
    phone: "99999999"
  },
  {
    id: 2569,
    user_name: "test",
    first_name: "Helge",
    last_name: "Petersen",
    email: "helge.petersen@gls-denmark.com",
    phone: "25241153",
    company: Object.assign({}, init_company),
    accounts: JSON.parse(JSON.stringify(init_courier_accounts)),
    default_account: Object.assign({}, init_courier_default_account),
    settings: JSON.parse(JSON.stringify(init_courier_settings))
  },
  {
    id: 123,
    user_name: "test",
    first_name: "Helge",
    last_name: "Petersen",
    email: "helge.petersen@gls-denmark.com",
    phone: "25241153",
    company: Object.assign({}, init_company),
    accounts: JSON.parse(JSON.stringify(init_distribution_accounts)),
    default_account: Object.assign({}, init_distribution_default_account),
    settings: JSON.parse(JSON.stringify(init_distribution_settings))
  }
];

export default {
  // logins,
  users
};
